
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSnow as ObiLightningSnowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-snow.js';
 
 
 

 
 export const ObiLightningSnow = createComponent({
   react: React,
   tagName: 'obi-lightning-snow',
   elementClass: ObiLightningSnowElement,
   events: {
     
   }
  });
 
 